const COMPANY_NAMES = ['бюро', 'бюро горбунова']

module.exports = (name) => COMPANY_NAMES.includes(name.toLowerCase())
